import selectComponent from 'utilities/select-component'
import 'waypoints/lib/jquery.waypoints'
import 'sticky-kit/dist/sticky-kit'

export default class FixedQuote {
    constructor(element) {
        this.$component = selectComponent(element)
        this.$quoteButton = $('#nav_cta')

        this.addStick()
    }

    addStick() {
        const waypoint = new Waypoint({
            element: this.$component,
            handler: direction => {
                if (direction == 'down') {
                    this.$quoteButton.css('display', 'block')
                }
                if (direction == 'up') {
                    this.$quoteButton.css('display', 'none')
                }
            },
            offset: 66
        })
    }
}
